import { convertCurrency, getValueWithoutSymbol } from "../helpers";

export function onAmountChange(value, usdValue, donationForm, paymentElement = null) {console.log('onAmountChange');
  const realValue = value ?? donationForm.getStorage().amounts?.value;
        
  donationForm.saveFormInStorage("amounts", {
    value: String(realValue).replaceAll(',', ''),
    usdValue: String(usdValue).replaceAll(',', ''),
  });
  paymentElement?.updatePaymentElement(donationForm);
};

export function onCurrencySelected(currency, donationForm) {
  donationForm.saveFormInStorage("currency_code", currency);
};

export function afterAmountUpdate(donationForm) {
  donationForm.updateDonationText(donationForm.getStorage());
};

export async function updateHandlesAmounts(fromCurrency, toCurrency, handlesRadio, selectCurrencyAmount, donationForm, otherOptionText = "Other", paymentElement = null) {
  if (fromCurrency === toCurrency) {
    return;
  }
  if (toCurrency !== donationForm.defaultCurrency) {
    handlesRadio.handlesContainer.style.display = 'none';
    handlesRadio.handlesContainer.style.opacity = '0';
    return updateSelectAmounts(fromCurrency, toCurrency, selectCurrencyAmount, donationForm, otherOptionText, paymentElement);
  }
  const currencyAmountContainer = selectCurrencyAmount.currencyAmountContainer;
  currencyAmountContainer.style.display = 'none';
  currencyAmountContainer.style.opacity = '0';

  handlesRadio.handlesContainer.style.display = 'block';
  handlesRadio.handlesContainer.style.opacity = '100';

  const otherQtyCurrencySpan = handlesRadio.otherAmountInput.sufix;
  otherQtyCurrencySpan.textContent = "$";

  const otherQtyCurrencyInput = handlesRadio.otherAmountInput.otherInput;
  if(handlesRadio.otherAmountInput.sufix?.id) otherQtyCurrencyInput.style.paddingLeft = toCurrency === 'USD' ? "25px" : "48px";

  const selectedAmount = handlesRadio.amountRadios;
  let amountSelectedItem = -1;

  for (var i = 0; i < selectedAmount.length; i++) {
    if (selectedAmount[i].checked) {
      amountSelectedItem = i;
      break;
    }
  }

  if (amountSelectedItem > -1) {
    if (selectedAmount[amountSelectedItem].value?.toLowerCase() === "other") {
       onAmountChange(null, donationForm.getStorage()?.amounts?.usdValue, donationForm, paymentElement);
    } else {
      const selectedValue = getValueWithoutSymbol(selectedAmount[amountSelectedItem].parentNode.children[handlesRadio.elementValueIndex].innerHTML, toCurrency);
      const usdValue = toCurrency === 'USD'? selectedValue : await convertCurrency(toCurrency, "USD", selectedValue);
      onAmountChange(selectedValue, usdValue, donationForm, paymentElement);
    }
  }
}

export async function updateSelectAmounts(fromCurrency, toCurrency, selectCurrencyAmount, donationForm, otherOptionText = "Other", paymentElement = null) {
  if (fromCurrency === toCurrency) {
    return;
  }

  const otherQtySelectSpan = selectCurrencyAmount.otherAmountInput.sufix;
  if (otherQtySelectSpan) otherQtySelectSpan.innerHTML = toCurrency;

  const otherQtySelectInput = selectCurrencyAmount.otherAmountInput.otherInput;
  if(otherQtySelectSpan?.id) otherQtySelectInput.style.paddingLeft = "45px";

  const selectedAmount = document.getElementById(`Amount${selectCurrencyAmount.currentTime}`);

  const selectOptionsAmounts = selectCurrencyAmount.optionsValues.join('-');
  let newValues = await convertCurrency(fromCurrency, toCurrency, selectOptionsAmounts);
  const selectValues = newValues.split('-');
  selectValues.push(otherOptionText);
  
  Object.entries(selectValues).forEach(([i, value]) => {
    selectedAmount.options[i].innerHTML = `${ value ===otherOptionText  ? '' : toCurrency } ${value}`;
  });

  if (selectedAmount?.value === otherOptionText) {
    let otherValue = otherQtySelectInput.value;
    if (otherValue) {
      otherValue = await convertCurrency(fromCurrency, toCurrency, otherValue);
      otherQtySelectInput.value = otherValue;
    }

    const usdValue = toCurrency === 'USD'? otherValue : await convertCurrency(toCurrency, "USD", otherValue);
    onAmountChange(otherValue, usdValue, donationForm, paymentElement);
  } else {
    const newAmount = getValueWithoutSymbol(selectedAmount.options[selectedAmount.selectedIndex]?.text, toCurrency);
    const usdValue = toCurrency === 'USD'? newAmount : await convertCurrency(toCurrency, "USD", newAmount);
    onAmountChange(newAmount, usdValue, donationForm, paymentElement);

  }
  const selectContainer = selectCurrencyAmount.currencyAmountContainer;
  selectContainer.style.display = 'block';
  selectContainer.style.opacity = '100';

}

export async function updatePledgeAmounts(fromCurrency, toCurrency, handlesRadio, donationForm, otherOptionText = "Other", paymentElement = null) {
  if (fromCurrency === toCurrency) {
    return;
  }

  // Support Map or Array of handles (e.g. in multi-pledge)
  const handlesList = handlesRadio instanceof Map 
    ? Array.from(handlesRadio.values()) 
    : (Array.isArray(handlesRadio) ? handlesRadio : [handlesRadio]);

  for (const handle of handlesList) {
    if (!handle) continue;
    const otherQtySelectSpan = handle.otherAmountInput?.sufix;
    if (otherQtySelectSpan) otherQtySelectSpan.innerHTML = toCurrency;

    const otherQtySelectInput = handle.otherAmountInput?.otherInput;
    if (otherQtySelectSpan?.id && otherQtySelectInput) {
      otherQtySelectInput.style.paddingLeft = "50px";
    }

    let radioValues = [...(handle.optionsValues || [])];
    if (toCurrency !== handle.baseCurrencyCode && radioValues.length > 0) {
      const selectOptionsAmounts = radioValues.join('-');
      let newValues = await convertCurrency(handle.baseCurrencyCode, toCurrency, selectOptionsAmounts);
      radioValues = newValues.split('-');
    }
    radioValues.push(otherOptionText);

    for (let i = 0; i < radioValues.length; i++) {
      const newValue = radioValues[i];
      let radio = handle.amountRadios?.[i];
      if (!radio) continue;
      let newAmount = newValue;
      let pledgeEl = radio.parentElement?.querySelector(handle.labelSelector);
      var value = radio.value?.split("-");
      let pledgeText = value?.length > 1 ? value[1] : "";
      radio.value = `${toCurrency} ${newValue}-${pledgeText}`;

      if (newValue === otherOptionText) {
        let otherValue = otherQtySelectInput?.value || 0;
        if (otherValue) {
          otherValue = await convertCurrency(fromCurrency, toCurrency, otherValue);
          if (otherQtySelectInput) otherQtySelectInput.value = otherValue;
        }
        newAmount = otherValue;
        pledgeText = "";
      } else {
        handle.generateAmountLabel?.(radio.id, pledgeEl, toCurrency, newValue, pledgeText);
      }

      if (radio.checked) {
        const usdValue = toCurrency === 'USD' ? newAmount : await convertCurrency(toCurrency, "USD", newAmount);
        if (!handle.isMultiPledge) {
          onAmountChange(newAmount, usdValue, donationForm, paymentElement);
          donationForm.saveFormInStorage("pledge_message", pledgeText);
        } else {
          handle.onAmountSelected?.(newAmount, usdValue, pledgeText, handle.amountRadioNames);
        }
      }
    }
  }
}
